import React, { createContext, useContext, useEffect, useState } from "react";
import { getCompanies } from "../API/Backend";

const STORAGE_KEY = "ACTIVE_CLIENT";
const ClientContext = createContext(null);

export function ClientProvider({ children }) {
  const [clients, setClients] = useState([]);
  const [activeClient, setActiveClientState] = useState(
    localStorage.getItem(STORAGE_KEY) || ""
  );
  const [loading, setLoading] = useState(true);

  const setActiveClient = (clientName) => {
    setActiveClientState(clientName);
    try {
      localStorage.setItem(STORAGE_KEY, clientName);
    } catch (err) {
      console.error("Unable to persist active client:", err);
    }
  };

  const fetchClients = () => {
    setLoading(true);
    return getCompanies()
      .then(({ data }) => {
        const companies = (data && data.data) || [];
        setClients(companies);
        const stillValid = companies.some((c) => c.clientName === activeClient);
        if (!stillValid && companies.length > 0) {
          setActiveClient(companies[0].clientName);
        }
        return companies;
      })
      .catch((err) => {
        console.error("Error fetching companies:", err);
        return [];
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchClients();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ClientContext.Provider
      value={{ clients, activeClient, setActiveClient, loading, refreshClients: fetchClients }}
    >
      {children}
    </ClientContext.Provider>
  );
}

export function useClient() {
  const ctx = useContext(ClientContext);
  if (!ctx) {
    throw new Error("useClient must be used within a ClientProvider");
  }
  return ctx;
}
